export const V_SCROLLBAR_WIDTH = 17;
export const H_SCROLLBAR_WIDTH = 17;
export const MIN_DRAG_X = 2;
export const MIN_DRAG_Y = 2;